import { render, staticRenderFns } from "./ControleResponsavelEstado.vue?vue&type=template&id=d5cb6662&"
import script from "./ControleResponsavelEstado.vue?vue&type=script&lang=js&"
export * from "./ControleResponsavelEstado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports